class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverCloseTimer = null;

    // Progressive enhancement: retain Dawn's native click/keyboard behavior,
    // and add hover only for fine pointers at the desktop breakpoint.
    this.addEventListener('pointerenter', this.openOnHover.bind(this));
    this.addEventListener('pointerleave', this.closeOnHover.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  openOnHover(event) {
    if (!window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches) return;

    window.clearTimeout(this.hoverCloseTimer);
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
    this.onToggle();
  }

  closeOnHover(event) {
    if (!window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches) return;

    // Allow the pointer to cross the small visual gap between trigger and panel.
    this.hoverCloseTimer = window.setTimeout(() => {
      this.close();
    }, 250);
  }
}

customElements.define('header-menu', HeaderMenu);
